module.exports = __webpack_public_path__ + "static/media/cookies.df68c425.svg";